import { createSlice } from '@reduxjs/toolkit';

const ThemeSlice = createSlice({
  name: 'theme mode',
  initialState: 'Light',
  reducers: {
    ToggleThemeMode: (state) => {
      return state === 'Light' ? 'Dark' : 'Light';
    },
  },
});

export const { ToggleThemeMode } = ThemeSlice.actions;
export default ThemeSlice.reducer;
